module.exports = __webpack_public_path__ + "assets/img/20_1050_big.f24ae41a.jpg";